import { render, staticRenderFns } from "./ClienteAvatar.vue?vue&type=template&id=01f37282&scoped=true"
import script from "./ClienteAvatar.vue?vue&type=script&lang=js"
export * from "./ClienteAvatar.vue?vue&type=script&lang=js"
import style0 from "./ClienteAvatar.vue?vue&type=style&index=0&id=01f37282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f37282",
  null
  
)

export default component.exports